enum TipoCapsula {
    Normal = 1,
    Revestida = 2,
    Vegana = 3,
    VeganaRevestida = 4,
    Pullulan = 5,
}

export default TipoCapsula;
